export default {
    Search: 'جستجو',
    'No results found.': 'نتیجه‌ای یافت نشد.',
    cancel: 'انصراف'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/searchfield/translations/fa.js
// module id = 518
// module chunks = 0